
import { useState, useEffect } from 'react';
import { API_BASE } from '../config';

export default function WhatsAppPairing({ token, apiBase, t }) {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchStatus();
  }, []);

  const fetchStatus = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/whatsapp/pairing/status`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      setStatus(data);
    } catch (e) {
      console.error(e);
    }
  };

  const generateCode = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_BASE}/api/whatsapp/pairing/generate`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setCode(data.code);
      } else {
        setError(data.error || 'Erreur');
      }
    } catch (e) {
      setError('Erreur reseau');
    } finally {
      setLoading(false);
    }
  };

  const unpair = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/whatsapp/pairing/unpair`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setStatus({ paired: false, whatsappNumber: null });
        setCode('');
      }
    } catch (e) {
      console.error(e);
    }
  };

  if (!status) return <p style={{ color: 'var(--text-secondary)' }}>Chargement...</p>;

  return (
    <div style={{ padding: '20px 0' }}>
      <h3 style={{ marginBottom: 16 }}>📱 WhatsApp</h3>

      <div style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border)',
        borderRadius: 12,
        padding: 24,
        maxWidth: 500
      }}>
        {status.paired ? (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
              <span style={{ fontSize: 24 }}>✅</span>
              <div>
                <div style={{ fontWeight: 600 }}>Compte lie</div>
                <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{status.whatsappNumber}</div>
              </div>
            </div>
            <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 16 }}>
              Envoyez vos questions par WhatsApp. Les agents IA debattront et vous recevrez la reponse.
            </p>
            <button
              onClick={unpair}
              style={{
                background: 'none', border: '1px solid var(--error)', color: 'var(--error)',
                padding: '6px 16px', borderRadius: 6, cursor: 'pointer', fontSize: 13
              }}
            >
              Delier
            </button>
          </>
        ) : (
          <>
            <p style={{ marginBottom: 16, fontSize: 14 }}>
              Liez votre compte Cogency a WhatsApp pour envoyer des questions directement.
            </p>

            {!code ? (
              <button
                onClick={generateCode}
                disabled={loading}
                className="btn-primary"
                style={{ width: '100%' }}
              >
                {loading ? '...' : 'Generer un code de liaison'}
              </button>
            ) : (
              <div style={{ textAlign: 'center' }}>
                <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 8 }}>
                  Envoyez ce code par WhatsApp au numero Cogency :
                </p>
                <div style={{
                  fontSize: 32, fontWeight: 700, letterSpacing: 4,
                  background: 'var(--bg-hover)', padding: '12px 24px',
                  borderRadius: 8, display: 'inline-block', marginBottom: 12,
                  fontFamily: 'monospace'
                }}>
                  {code}
                </div>
                <p style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                  Code valable 10 minutes
                </p>
              </div>
            )}

            {error && <p style={{ color: 'var(--error)', fontSize: 13, marginTop: 8 }}>{error}</p>}

            {!status.connected && (
              <p style={{ marginTop: 16, fontSize: 12, color: '#f59e0b' }}>
                ⚠️ Le service WhatsApp n'est pas connecte. Contactez l'administrateur.
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
